import { render, staticRenderFns } from "./TrafficList.vue?vue&type=template&id=ace5954e&scoped=true"
import script from "./TrafficList.vue?vue&type=script&lang=js"
export * from "./TrafficList.vue?vue&type=script&lang=js"
import style0 from "./TrafficList.vue?vue&type=style&index=0&id=ace5954e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace5954e",
  null
  
)

export default component.exports